
/**
 * 右侧二维码操作
 * @param {*} container 
 * @param {*} hideCls 
 */
const adQrcode = (container, hideCls = 'Hide') => {
    let closeBtn = container.find('.close'),
        adContainter = container.find('.qrcode-container');
    
    closeBtn.on('click', function(e) {
        adContainter.addClass(hideCls)
        e.stopPropagation();
    })

}

export default {
    init: (container) => {
        adQrcode(container)

    }
}



// WEBPACK FOOTER //
// ./modules/logo-input/js/ad-qrcode.js